// Mobile collapsible sections handler with smooth animations
(function() {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    const collapsibles = document.querySelectorAll('.tempests-pdp .mobile-collapsible');
    if (!collapsibles.length) return;

    console.log('📱 Mobile Collapsible: Found', collapsibles.length, 'sections');

    collapsibles.forEach(details => {
      const summary = details.querySelector('summary');
      const content = details.querySelector('.mobile-collapsible__content');
      
      if (!summary || !content) return;

      // Prevent default details behavior and handle it manually
      summary.addEventListener('click', (e) => {
        // Only animate on mobile
        if (window.innerWidth >= 750) return;
        
        e.preventDefault();
        
        if (details.hasAttribute('open')) {
          closeDetails(details, content);
        } else {
          openDetails(details, content);
        }
      });
    });

    function openDetails(details, content) {
      details.style.overflow = 'hidden';
      details.setAttribute('open', '');
      
      // Get the height
      const contentHeight = content.scrollHeight;
      
      // Animate from 0 to full height
      content.style.height = '0px';
      
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          content.style.height = contentHeight + 'px';
          
          // Clean up after animation
          setTimeout(() => {
            content.style.height = '';
            details.style.overflow = '';
          }, 900);
        });
      });
    }

    function closeDetails(details, content) {
      details.style.overflow = 'hidden';
      
      // Get current height
      const contentHeight = content.scrollHeight;
      content.style.height = contentHeight + 'px';
      
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          content.style.height = '0px';
          
          // Remove open attribute after animation
          setTimeout(() => {
            details.removeAttribute('open');
            content.style.height = '';
            details.style.overflow = '';
          }, 900);
        });
      });
    }

    function updateCollapsibles() {
      const isDesktop = window.innerWidth >= 750;
      
      collapsibles.forEach(details => {
        if (isDesktop) {
          // Force open on desktop without animation
          details.setAttribute('open', '');
        }
      });
      
      console.log('📱 Collapsibles updated for:', isDesktop ? 'Desktop' : 'Mobile');
    }

    // Initial update
    updateCollapsibles();

    // Handle resize
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(updateCollapsibles, 100);
    });

    console.log('✅ Mobile Collapsible: Initialized with smooth animations');
  }
})();

